import { render, staticRenderFns } from "./AiCreditsBanner.vue?vue&type=template&id=1cad3815&"
import script from "./AiCreditsBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AiCreditsBanner.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports